export default __webpack_public_path__ + "static/media/6-3.008e438a.mp3";